import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-scheduler',
  templateUrl: './main-scheduler.component.html',
  styleUrls: ['./main-scheduler.component.css']
})
export class MainSchedulerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
